module.exports = __webpack_public_path__ + "static/img/yaozhai-opt.914ff8b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yaozhai-opt.jpg
// module id = z7KG
// module chunks = 4